import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  notification,
  Row,
  Spin,
  Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { CheckOutlined } from '@ant-design/icons';
import { useGetSubscriptionMutation } from '../slices/subscriptionApiSlice';
import { setSubscriptions } from '../slices/subscriptionSlice';
import { useGetSubMutation } from '../slices/usersApiSlice';
import moment from 'moment-timezone';

const SubscriptionScreen = () => {
  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { darkmode } = useSelector((state) => state.darkmode);
  const { subscription } = useSelector((state) => state.subscription);
  const [getSubscription, { isLoading: isSubLoading }] = useGetSubscriptionMutation();
  const [getmySub, { isLoading: ismyLoading }] = useGetSubMutation();
  const [currentPlan, setCurrentPlan] = useState(null);
  const [subid, setSubid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [btloading, setBtloading] = useState(false);
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const { Title, Text } = Typography;

  const getSubscriptiondata = async () => {
    try {
      const res = await getSubscription().unwrap();
      dispatch(setSubscriptions({ ...res }));
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };

  const getMysub = async () => {
    try {
      const res = await getmySub().unwrap();
      setCurrentPlan(res.subscription);
      setSubid(res.subid);
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };

  useEffect(() => {
    getSubscriptiondata();
    getMysub();
  }, []);

  // const checkoutHandler = async (amount, name, id) => {
  //   setBtloading(true);
  //   axios.defaults.withCredentials = true;

  //   const { data: { key } } = await axios.post(`${process.env.REACT_APP_BACKEND}/api/v1/payment/getkey`);
  //   const { data: { order } } = await axios.post(`${process.env.REACT_APP_BACKEND}/api/v1/payment/checkout`, {
  //     amount, id
  //   });

  //   const options = {
  //     key: key,
  //     amount: order.amount,
  //     currency: "INR",
  //     name: name,
  //     description: "Lincfolio Subscription Plan",
  //     image: "http://localhost:3000/logo.png",
  //     order_id: order.id,
  //     callback_url:` ${process.env.REACT_APP_BACKEND}/api/v1/payment/paymentverification`,
  //     prefill: {
  //       name: userInfo.firstname + ' ' + userInfo.lastname,
  //       email: userInfo.email,
  //     },
  //     theme: {
  //       color: "#2f3640"
  //     }
  //   };
  //   const razor = new window.Razorpay(options);
  //   razor.open();
  //   setBtloading(false);
  // };

  const checkoutHandler = async (amount, name, id) => {
    setLoadingPlanId(id); // set loading for that specific plan
    try {
      axios.defaults.withCredentials = true;

      const { data: { key } } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/getkey`);
      const { data: { order } } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/checkout`, {
        amount, planId:id
      });

      const options = {
        key: key,
        amount: order.amount,
        currency: "INR",
        name: name,
        description: "Lincfolio Subscription Plan",
        image: "https://testapp.lincfolio.com//logo.png",
        order_id: order.id,
        callback_url: ` ${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/paymentverification`,
        prefill: {
          name: userInfo.firstname + ' ' + userInfo.lastname,
          email: userInfo.email,
        },
        theme: {
          color: "#2f3640"
        }
      };
      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      notification.error({ message: 'Subscription failed' });
    } finally {
      setLoadingPlanId(null);
    }
  };




  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: darkmode ? "#1f1f1f" : "#ffffff",
        color: darkmode ? "#f0f0f0" : "#000000",
        minHeight: "100vh",
        borderRadius: "5px",
      }}
    >
      {contextHolder}

      <Row>
        <Col flex={"auto"}>
          <Breadcrumb
            items={[{ title: 'Dashboard' }, { title: 'My Subscriptions' }]}
            style={{ marginBottom: "5px", color: darkmode ? "#f0f0f0" : "#000" }}
          />
        </Col>
      </Row>

      <Divider style={{ borderColor: darkmode ? "#555" : undefined }} />

      {ismyLoading ? (
        <Spin tip="Loading current subscription...">
          <div style={{ height: '200px' }} />
        </Spin>
      ) : (
        <>
          {currentPlan && currentPlan.status !== "deactive" ? (
            <Alert
              message={`You are currently subscribed to the ${subid?.name}`}
              description={`Status: ${currentPlan.status} | Next Billing Date: ${moment(currentPlan.endDate).format("DD-MMM-YYYY")}`}
              type="success"
              showIcon
              style={{
                backgroundColor: darkmode ? "#333" : "#f6ffed",
                color: darkmode ? "#ffffff" : undefined,
                border: darkmode ? "1px solid #555" : undefined,
                marginBottom: '1rem',
              }}
            />
          ) : (
            <Alert
              message="You are not currently subscribed to any plan."
              type="warning"
              showIcon
              style={{
                backgroundColor: darkmode ? "#444" : undefined,
                color: darkmode ? "#ffffff" : undefined,
                border: darkmode ? "1px solid #666" : undefined,
                marginBottom: '1rem',
              }}
            />
          )}

          <Divider orientation="left" style={{ fontFamily: 'Cormorant, serif', color: darkmode ? "#ffffff" : "#000", fontSize: "20px" }}>
            Available Plans
          </Divider>
          <Row gutter={[16, 16]}>
  {subscription != null &&
    subscription.map((plan) => (
      <Col xs={24} sm={12} md={8} lg={8} key={plan.name}>
        <Card
          bordered={false}
          style={{
            backgroundColor: "#000",
            color: "#fff",
                height: '400px',

            border:
              currentPlan?.plan_id === plan._id
                ? "2px solid #9D7F3B"
                : "",
            borderRadius: "24px",
            padding: "40px 30px",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        bodyStyle={{
  padding: 0,
  display: "flex",
  flexDirection: "column",
  flex: 1
}}
        >
   <div style={{ flex: 1 }}>
    <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          {/* Popular Ribbon */}
          {plan?.popular && (
            <div
              style={{
                position: "absolute",
                top: 12,
                right: -40,
                transform: "rotate(45deg)",
                background: "#9D7F3B",
                color: "#fff",
                padding: "4px 40px",
                fontSize: "12px",
                fontWeight: 600,
                letterSpacing: "1px",
              }}
            >
              POPULAR
            </div>
          )}

          {/* Plan Name */}
          <div style={{ textAlign: "center" }}>
            <div
              style={{
                fontFamily: "Michroma",
                fontSize: "18px",
                letterSpacing: "2px",
              }}
              >
              {plan.name}
            </div>
          </div>

          {/* Price */}
          <div style={{ textAlign: "center", marginTop: "4px" }}>
            <div
              style={{
                fontSize: "30px",
                fontWeight: 200,
                fontFamily: "Michroma",
                marginTop:"20px",
              }}
            >
              ₹ {plan.price}
            </div>

            {/* <div
              style={{
                marginTop: "2px",
                fontSize: "14px",
                color: "#ccc",
              }}
            >
              ₹{plan.price} / Month
            </div> */}
          </div>

          {/* Divider */}
          {/* <div
            style={{
              height: "1px",
              background: "#333",
              margin: "10px 0",
            }}
          /> */}

          {/* Highlight
          <div
            style={{
              textAlign: "center",
              fontSize: "14px",
            }}
          >
            {plan?.highlights?.[0] || "Track daily performance"}
          </div> */}

          

          {/* Divider */}
          {/* <div
            style={{
              height: "1px",
              background: "#333",
              margin: "10px 0",
            }}
          /> */}

          {/* Tax */}
          <div
            style={{
              textAlign: "center",
              fontSize: "13px",
              color: "#ccc",
            }}
          >

   <div style={{ marginTop: "5px" }}>
  {plan?.highlights?.map((item, index) => (
    <React.Fragment key={index}>
      
      <div
        style={{
          textAlign: "center",
          fontSize: "14px",
          padding: "6px 0",
          color: index === 1 ? "#facc15" : "#fff"
        }}
      >
        {item}
      </div>

      {/* Divider after each feature */}
      {index !== plan.highlights.length - 1 && (
        <div
          style={{
            height: "1px",
            background: "#333",
            margin: "6px 0",
          }}
        />
      )}

    </React.Fragment>
  ))}
</div>        

</div>  </div>

          {/* Button */}
          <div
           style={{
    marginTop: "auto",
    textAlign: "center",
    paddingTop: "15px"
  }}

          >
            {currentPlan?.planId?.toString() ===
            plan.id?.toString() ? (
              <Button
                icon={<CheckOutlined />}
                disabled
                style={{
                  // background: "#9D7F3B",
                  border: "none",
                  borderRadius: "999px",
                  height: "48px",
                  minWidth: "180px",
                  color: "#fff",
                  fontFamily: "Michroma",
                }}
                className='gold-btn'
              >
                CURRENT PLAN
              </Button>
            ) : (
              // <Button
              //   type="primary"
              //   loading={loadingPlanId === plan._id}
              //   onClick={() =>
              //     checkoutHandler(
              //       plan.price * 100,
              //       plan.name,
              //       plan.id
              //     )
              //   }
              //   className='gold-btn'
              //   style={{
              //     // background: "#9D7F3B",
              //     border: "none",
              //     borderRadius: "999px",
              //     height: "48px",
              //     minWidth: "180px",
              //     fontFamily: "Michroma",
              //     letterSpacing: "1px",
              //   }}
              // >
              //   SUBSCRIBE
              // </Button>



      <Button
        type="primary"
        style={{
          backgroundColor: "#D1A954",
          color: "#fff",
          fontFamily: 'Cormorant, serif',
          border: "none",
          borderRadius: "9999px",
          padding: "8px 24px",
          fontSize: "20px",
          minWidth: "160px",
          height: "48px",
        }}

          className='gold-btn'
        loading={loadingPlanId === plan._id}
        onClick={() => checkoutHandler(plan.price * 100, plan.name, plan.id)}
      >
        {plan.price > 0 ? `SUBSCRIBE` : 'SUBSCRIBE FOR FREE'}
      </Button>
            )}
          </div>
          </div>
        </Card>
      </Col>
    ))}
</Row>
        </>
      )}
    </div>
  );
};

export default SubscriptionScreen;





